import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Components

import BlockWrapper from './BlockWrapper';



// Utils

import { householdMemberTools } from '@utils/tools/householdMemberTools';

// Styles

import { darculaBloodRelationshipsInfoStyles } from '../darculaTheme';

const {
    blockWrapperAdditionalStyles,
    relationTooltipContentStyle,
    relationTooltipPersonNameStyle,
    relationTooltipMutedStyle,
    relationTypeTextStyle,
    brChipBaseStyle,
    brChipBackgroundMissingRelation,
    brChipBackgroundHasRelation,
    brPropRowStyle,
    brPropRowNullStyle,
    hoverTooltipPanelStyle,
    groupChunkStyle,
} = darculaBloodRelationshipsInfoStyles;

const BloodRelationshipsInfo = ({ id }) => {

    const bloodRelationship = useSelector(
        state => state.ssap.data.taxHousehold.bloodRelationship
    );
    const householdMembers = useSelector(
        state => state.ssap.data.taxHousehold.householdMember
    );
    const loadedRelations = useSelector(state => state.ssap.relations.loadedRelations);

    const [ description, toggleDescription ] = useState(null);

    const handleMouseHovering = (e, br) => {
        toggleDescription({
            br,
            mousePosition: { x: e.clientX, y: e.clientY }
        });
    };

    const handleMouseLeaving = () => {
        toggleDescription(null);
    };

    const getRelation = () => {
        const extract = householdMemberTools.extractFromHouseholdMembers(householdMembers);
        return (
            <div style={ relationTooltipContentStyle }>
                <div style={ relationTooltipPersonNameStyle }>
                    { extract.getFullNameByHhmGuid(description.br.personGuid) }
                </div>
                <span style={ relationTooltipMutedStyle }>
                    &nbsp;→&nbsp;
                </span>
                <div style={ relationTooltipPersonNameStyle }>
                    { extract.getFullNameByHhmGuid(description.br.relatedPersonGuid) }
                </div>
                <div style={ relationTypeTextStyle }>
                    { (br => br ? br.type : 'BR not found')(
                        loadedRelations.find(br => br.code === description.br.relation)
                    ) }
                </div>
            </div>
        );
    };

    const getRelationships = () => {

        const preparedBloodRelationships = Object.values(bloodRelationship.reduce((res, br) => {
            return res[br.personGuid] ?
                { ...res, [br.personGuid]: [ ...res[br.personGuid], br  ] } :
                { ...res, [br.personGuid] : [ br ] };
        }, {}));

        return preparedBloodRelationships
            .map((chunk, idx) => {

                const getRelationsForTheSamePerson = chunk => {

                    return chunk.map(br => {
                        const {
                            relation,
                            personGuid,
                            relatedPersonGuid
                        } = br;

                        const chipBackground = relation === null
                            ? brChipBackgroundMissingRelation
                            : brChipBackgroundHasRelation;

                        return (
                            <span
                                key={ `${personGuid}_${relatedPersonGuid}` }
                                style={{
                                    ...brChipBaseStyle,
                                    ...chipBackground,
                                }}
                                onMouseEnter={ e => handleMouseHovering(e, br) }
                                onMouseLeave={ () => handleMouseLeaving() }
                            >
                                { Object.entries(br).map(([ propName, value ]) => {
                                    return (
                                        <span
                                            key={ `${personGuid}_${relatedPersonGuid}_${propName}` }
                                            style={
                                                value === null
                                                    ? brPropRowNullStyle
                                                    : brPropRowStyle
                                            }
                                        >
                                            { `${propName}: ${value}` }
                                        </span>
                                    );
                                }) }
                                {
                                    description &&
                                    <span
                                        style={{
                                            ...hoverTooltipPanelStyle,
                                            top: description.mousePosition.y,
                                            left: description.mousePosition.x,
                                        }}
                                    >
                                        { getRelation() }
                                    </span>
                                }
                            </span>
                        );
                    });
                };

                return (
                    <span
                        key={ idx }
                        style={ groupChunkStyle }
                    >
                        {
                            getRelationsForTheSamePerson(chunk)
                        }
                    </span>
                );
            });
    };


    return (
        <BlockWrapper id={ id } additionalStyles={ blockWrapperAdditionalStyles }>
            { getRelationships() }
        </BlockWrapper>
    );
};

export default BloodRelationshipsInfo;
